import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, FileText, Download, Zap, Settings } from "lucide-react";
import ProductDemo from "./ProductDemo";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-32">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-3/4 right-1/4 w-64 h-64 bg-pink-200/30 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-orange-800 text-sm font-medium mb-8 animate-fade-in">
            <Zap size={16} className="mr-2" />
            Available on Salesforce AppExchange
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-snug">
            Your Salesforce Data, Your Documents
            <span className="block pb-1 text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500">
              Perfectly Aligned
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-4xl mx-auto leading-relaxed">
            QuillStudio ensures every PDF you generate matches your Salesforce records, so you can focus on customers, not formatting.
          </p>

          {/* Key Benefits */}
          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <div className="flex items-center bg-white/60 backdrop-blur-sm px-4 py-3 rounded-lg border border-slate-200/50">
              <FileText className="text-orange-600 mr-2" size={20} />
              <span className="text-slate-700 font-medium">Smart Field Merging</span>
            </div>
            <div className="flex items-center bg-white/60 backdrop-blur-sm px-4 py-3 rounded-lg border border-slate-200/50">
              <Zap className="text-pink-600 mr-2" size={20} />
              <span className="text-slate-700 font-medium">Fast & Simple Setup</span>
            </div>
            <div className="flex items-center bg-white/60 backdrop-blur-sm px-4 py-3 rounded-lg border border-slate-200/50">
              <Settings className="text-orange-500 mr-2" size={20} />
              <span className="text-slate-700 font-medium">Secure & Native</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <Button
              size="lg"
              className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-8 py-4 text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              onClick={() => window.open('https://appexchange.salesforce.com', '_blank')}
            >
              Install from AppExchange
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="border-2 border-slate-300 text-slate-700 hover:bg-slate-50 px-8 py-4 text-lg font-semibold transition-all duration-300"
              onClick={() => document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth' })}
            >
              See How It Works
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;